export const SYSTEM_NIT = 'SYSTEM'
// Espeja `core/constants.py::SYSTEM_BUSINESS_ID`: la consola admin no tiene empresa en la URL
// y su feedback se registra contra esta.
export const SYSTEM_BUSINESS_ID = '00000000-0000-0000-0000-000000000001'
export const LAST_BUSINESS_KEY = 'kairos_last_business'
// No hay flujo de mejora de plan: el CTA de cada bloqueo abre un mailto.
export const UPGRADE_CONTACT_EMAIL = 'hola@kairos.inciasociados.com'
export const SGSST_GROUP_BY_KEY = 'kairos_sgsst_group_by'
